import { Form } from 'antd';
import { COLOR_RED } from 'constants/colors';
import styled from 'styled-components';
import { Button, Skeleton } from 'UI';

export const InlineButton = styled(Button)`
  display: inline-flex;
  width: auto;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ItemInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ItemInfoRow = styled.span`
  display: flex;
  font-size: 14px;
  gap: 0.5rem;
`;

export const ItemInfoLabel = styled.span`
  font-weight: bold;
`;

export const ItemInfoValue = styled.span`
`;

export const FormContainer = styled(Form)`
  width: 100%;
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FormItemRow = styled.div`
  display: flex;
  gap: 1rem;
`;

export const BaseFormItem = styled(Form.Item)`
  margin: 0;
  min-width: 180px

  & > * {
    width: 100%;
  }
`;

export const AggregatorContainer = styled.div`
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TotalQuantityLabel = styled.span<{
  isInvalid: boolean
}>`
  display: flex;
  gap: 0.5rem;
  ${({ isInvalid }) => (isInvalid ? `color: ${COLOR_RED}` : '')}
`;

export const SeedBatchesSkeleton = styled(Skeleton)`
  padding-top: 1rem;
`;
